angular.module('bmsApp.settings').controller('UserRoleSaveCtrl',
	function ($scope, ngTableParams, $state, $q, UserPermissionSvc, UserRoleSvc, $timeout, notify) {

		$scope.updating = $state.is('main.settings.userRoles.edit');
		$scope.processing = false;
		$scope.formValidator = {};
		var promises = [];

		var params = {
			filter: {
				UserType: '',
				Visible: null,
				TopLevelOnly: true,
			}
		};
		promises.push(UserPermissionSvc.index(params));

		if ($scope.updating) {
			promises.push(UserRoleSvc.read($state.params.id));
		}

		$q.all(promises)
			.then(function (responses) {
				$scope.permissions = responses[0].data.permission_collection;

				if ($scope.updating) {
					$scope.role = responses[1].data.role;
				}
			});

		$scope.rolePermissionComparator = function (obj1, obj2) {
			return obj1.id === obj2.id;
		};

		$scope.submit = function (role) {
			$scope.processing = true;

			if ($scope.formValidator.valid()) {
				$scope.processing = true;

				var promise;
				promise = ($scope.updating) ?
					UserRoleSvc.update(role) :
					UserRoleSvc.create(role);

				promise.then(function (response) {
					notify({
						message: $scope.updating ? 'Role successfully updated' : 'Role successfully created'
					});
					processing = false;
					$state.go('main.settings.userRoles');
				}, function (error) {
					processing = false;
					$scope.errors = error;
				})
					.finally(function () {
						$scope.processing = false;
					});
			}
		};

	});





